const typography = {
  TAB_OVERVIEW: "Overview",
  TAB_ENGAGEMENT: "Engagement",
  TAB_WELLBEING: "Wellbeing",
  TAB_RESETS_CONTENT: "Resets & Content",
  TAB_PAYMENTS_LICENSING: "Payments & Licensing",
  TAB_INBOX: "Inbox",
  TAB_SETTINGS: "Settings",
  SETTINGS_INTRO:
    "These values are assumptions this dashboard reports against, not measurements. Changing one changes figures that may already have been shared, so every report prints the value it used.",
  TAB_PLATFORM_HEALTH: "Platform Health",
  // Was "Implementation" — this is the school-by-school comparison and
  // drill-down tab; the name now says that.
  TAB_IMPLEMENTATION: "School Insights",

  // Implementation
  IMPL_NOT_ENOUGH: "Not enough data yet",
  IMPL_CAP_PLAYBACK: "video and audio resets played through",
  IMPL_NOTE_PLAYBACK:
    "Share of video and audio resets that were played to the end. Counts only sessions that reported a start — the completion path does not always emit one, and counting both would show more finishing than began.",
  IMPL_RTT_DETAIL: "Every reset with a recorded outcome",
  IMPL_DONUT_CENTER: "back within 2 minutes",
  IMPL_BANDS_CENTER: "active classrooms",

  IMPL_NOT_ENOUGH_DETAIL:
    "No resets recorded a return-to-task time in this period. Figures appear once enough have been logged to report without identifying a single classroom.",
  IMPL_RTT_TITLE: "Time to Return to Task",

  // Tiles. Deliberately none of these repeat Section A's A1 totals (active
  // classrooms, active teachers, resets run) — two tiles for one number on two
  // tabs is two numbers to disagree.
  IMPL_FIG_MINUTES: "Time saved",
  IMPL_FIG_UNDER_TWO: "Back on task",
  IMPL_FIG_PLAYBACK: "Watched to the end",
  IMPL_FIG_STILL_TRYING: "Needs support",
  IMPL_NOTE_UNDER_TWO:
    "Share of resets whose recorded outcome put the class back on task inside two minutes. Counts only resets where a teacher logged an outcome — not every reset has one.",
  IMPL_NOTE_STILL_TRYING:
    "Classrooms using resets at exactly one moment in the day. Not a failure — these are the classrooms a coaching conversation would help most.",
  // Captions carry the qualifier the titles used to. "Back on Task Within 2
  // Min" became "Back on task" + "within 2 minutes" — same meaning, a title
  // that fits, and the denominator finally stated.
  IMPL_CAP_MINUTES: "classroom minutes, across the period",
  IMPL_CAP_UNDER_TWO: "within 2 minutes of the reset",
  IMPL_CAP_STILL_TRYING: "classrooms using one moment only",
  MOMENT_MODAL_SINGLE_EYEBROW: "Classrooms that may need support",
  MOMENT_MODAL_SINGLE_TITLE: "Using one reset moment only",
  MOMENT_MODAL_SINGLE_EMPTY: "Every active classroom is using resets at more than one moment.",
  MOMENT_ONLY_LABEL: "Only uses",
  IMPL_SEE_CLASSROOMS: "See classrooms",

  IMPL_BANDS_TITLE: "Classrooms by Grade Band",
  IMPL_BANDS_DETAIL: "Active classrooms only",
  IMPL_SPREAD_EMPTY: "No classrooms ran a reset in this period.",

  IMPL_MOMENTS_TITLE: "Resets by Moment in the Day",
  IMPL_MOMENTS_DETAIL: "Select a row to see the classrooms behind it",
  IMPL_CONTEXT_EMPTY:
    "No reset moment has enough resets to report yet. Rows below the aggregation threshold are hidden rather than shown with a small count.",

  MOMENT_MODAL_EYEBROW: "Classrooms using resets at",
  MOMENT_MODAL_EMPTY: "No classrooms used a reset at this moment in the selected period.",
  MOMENT_MODAL_ERROR: "Couldn't load these classrooms. Close and try again.",

  IMPL_DOWNLOAD_ERROR: "Couldn't generate the report. Please try again.",
  // School view
  SCHOOL_VIEW: "School view",
  SCHOOL_SEARCH_PLACEHOLDER: "Search schools or districts…",
  SCHOOL_MOST_ACTIVE: "Most active in this period",
  SCHOOL_MATCHES: "Matches",
  SCHOOL_NO_MATCH: "No school matches that.",
  SCHOOL_ALL_HINT: "District-wide roll-up",

  PLAYBACK_TITLE: "How Far Classes Get Through a Reset",
  PLAYBACK_DETAIL: "Video and audio playback, by share of sessions that started",
  PLAYBACK_COMPLETION: "of started resets are played to the end",
  PLAYBACK_EMPTY: "No video or audio reset has been played at this school in this period.",

  ACTIVITIES_TITLE: "Activity Breakdown",
  ACTIVITIES_DETAIL: "Every reset this school ran, strongest first",
  ACTIVITIES_EMPTY: "No resets recorded at this school in this period.",

  IMPL_DOWNLOAD: "Download summary (PDF)",
  IMPL_DOWNLOAD_DETAIL: "Uses the filters above. Intended for coaching conversations, not teacher evaluation.",


  DATE_RANGE: "Date Range",
  SCHOOL: "School",
  SECTION: "Section",
  ALL_SCHOOLS: "All schools",
  ALL_SECTIONS: "All sections",
  EXPORT_CSV: "Export CSV",
  REFRESH: "Refresh",
  REFRESH_HINT: "Clear cached figures and refetch from the server",
  AS_OF: "as of",
  AS_OF_LIVE: "live",


  // Engagement
  APP_OPENS: "App Opens",
  ACTIVE_USERS: "Active Users",
  SESSION_COUNT: "Sessions",
  AVG_SESSION_DURATION: "Avg. Session Length",
  SCREEN_VIEW_COUNT: "Features Used",
  DAILY_ACTIVE_USERS: "Daily Active Users",
  RETENTION_BY_WEEK: "Retention by Week Since Signup",
  FEATURE_USAGE: "Feature Usage Breakdown",

  // Wellbeing
  MOOD_COUNT: "Mood Check-ins",
  ACTIVE_MOOD_USERS: "Users Checking In",
  ANXIETY_COMPLETION: "GAD-7 Completion Rate",
  DEPRESSION_COMPLETION: "PHQ-9 Completion Rate",
  MOOD_TYPE_BREAKDOWN: "Mood Type Breakdown",
  STREAK_DISTRIBUTION: "Mood Streak Distribution",

  // Resets & Content
  BLS_COMPLETED: "BLS Sessions Completed",
  BLS_AVG_DURATION: "Avg. Session Length",
  BLS_AVG_RATING: "Avg. Rating",
  CLASS_INITIATED: "Teacher-Led Activities",
  PER_ACTIVITY_EMPTY: "Not tracked yet",
  PER_ACTIVITY_EMPTY_DETAIL:
    "Ships once the audio/video content tracking feature lands (AudioVideoContent / AudioTrack).",

  // A4 — usage trends
  USAGE_TRENDS_DAILY_TITLE: "Resets Over Time",
  USAGE_TRENDS_BY_HOUR_TITLE: "Resets by Hour of Day",
  USAGE_TRENDS_BY_CONTEXT_TITLE: "Resets by Context",
  USAGE_TRENDS_EMPTY: "No resets logged yet",
  USAGE_TRENDS_EMPTY_DETAIL: "This fills in once teachers start running resets in the selected range.",

  // A6 — most-used and most-helpful resets
  MOST_USED_TITLE: "Most-Used Resets",
  MOST_HELPFUL_TITLE: "Most-Helpful Resets",
  MOST_HELPFUL_SUBTITLE: "Ranked by average usefulness rating. Activities with fewer than 5 ratings are left off this list rather than ranked on too little data.",
  RANKING_COL_ACTIVITY: "Activity",
  RANKING_COL_USES: "Uses",
  RANKING_COL_RATING: "Avg. Rating",
  RANKING_COL_N: "n",
  RANKING_EMPTY: "No ratings yet",

  // A5 — aggregate state trends
  STATE_TRENDS_TITLE: "State Needs by Context",
  STATE_TRENDS_BY_HOUR_TITLE: "State Needs by Hour of Day",
  STATE_TRENDS_EMPTY: "No resets logged yet",
  STATE_TRENDS_EMPTY_DETAIL: "This fills in once teachers start running resets in the selected range.",
  STATE_TRENDS_INSUFFICIENT: "Fewer than 5 resets",
  STATE_TRENDS_NO_DATA: "No resets",

  // Payments & Licensing
  LICENSING_EMPTY: "Not tracked yet",
  LICENSING_EMPTY_DETAIL:
    "This tab activates automatically once school/district licensing ships (OrganizationLicense / LicenseSeat).",

  // Platform Health
  TOTAL_USERS: "Total Users",
  ENGAGED_USERS: "Engaged Users",
  IDLE_USERS: "Idle Users",
  SIGNUPS: "Signups",
  DELETED_USERS: "Deleted Users",
  TIME_OF_DAY: "Activity by Hour of Day",
  DAY_OF_WEEK: "Activity by Day of Week",

  // A1 — Overview totals
  ACTIVE_CLASSROOMS: "Active Classrooms",
  ACTIVE_TEACHERS: "Active Teachers",
  COMPLETED_RESETS: "Completed Resets",
  OVERVIEW_BY_SCHOOL_TITLE: "Schools Overview",
  OVERVIEW_COL_SCHOOL: "School",
  OVERVIEW_COL_DISTRICT: "District",
  OVERVIEW_COL_CLASSROOMS: "Classrooms",
  OVERVIEW_COL_TEACHERS: "Teachers",
  OVERVIEW_COL_COMPLETED: "Completed",
  OVERVIEW_SUPPRESSED: "Fewer than 5 resets",
  OVERVIEW_EMPTY: "No resets logged yet",
  OVERVIEW_EMPTY_DETAIL: "This fills in once teachers start running resets in the selected range.",
  OVERVIEW_NO_DISTRICT: "—",
   OVERVIEW_COL_RESETS_PER_TEACHER: "Resets / Teacher",
  OVERVIEW_COL_PCT_LOGGED: "% Logged",
  OVERVIEW_COL_AVG_RATING: "Avg. Rating",

  // A2 — adoption metrics
  REPEAT_USE_PCT: "Ran 2+ Resets",
  ACTIVE_LAST_14_PCT: "Active in Last 14 Days",
  WEEKLY_ADOPTION_TITLE: "Weekly Adoption",
  WEEKLY_ACTIVE_TEACHERS_SERIES: "Active teachers",
  WEEKLY_ACTIVATIONS_SERIES: "First-time activations",
  ADOPTION_SUPPRESSED_NOTE: "Weeks with fewer than 5 teachers are hidden for privacy.",

  // Overview — platform-wide widgets (no school/teacher breakdown; that
  // level of detail lives on Implementation and Resets & Content)
  OVERVIEW_MOMENTS_TITLE: "What Resets Are For",
  OVERVIEW_MOMENTS_DETAIL: "Every reset in range, by the moment it was run at — platform-wide.",
  OVERVIEW_MOMENTS_EMPTY: "No reset moments recorded yet",

  OVERVIEW_COMPLETION_TITLE: "Video & Audio Completion",
  OVERVIEW_COMPLETION_DETAIL: "How far students get through each activity, ranked by completion rate.",
  OVERVIEW_COMPLETION_EMPTY: "No video or audio activity has been played yet",
  OVERVIEW_COMPLETION_STARTS_TAB: "Completion rate",
  OVERVIEW_COMPLETION_COUNTS_TAB: "Starts vs. finishes",

  OVERVIEW_ENGAGEMENT_TITLE: "Teacher Portal Engagement",
  OVERVIEW_ENGAGEMENT_DETAIL: "How often teachers open the web portal, platform-wide — separate from the resets they go on to run.",
  OVERVIEW_ENGAGEMENT_EMPTY: "No teacher portal activity recorded yet",
  OVERVIEW_ENGAGEMENT_TREND_TAB: "Daily actives",
  OVERVIEW_ENGAGEMENT_RETENTION_TAB: "Retention",
  OVERVIEW_RETENTION_EXPLAINER:
    "Group teachers by the week they first opened the portal. Each bar is the percent of that same group who came back that many weeks later — a different group of teachers per bar, not one running total.",
  OVERVIEW_AUTH_EXPLAINER: "Each day's actives, coloured by how they signed in — password, Google, or Clever (their district's single sign-on).",

  // Classroom rollup
  CLASSROOM_ROLLUP_TITLE: "Classroom Rollup",
  SELECT_SECTION_PROMPT: "Select a school and section above to see per-student activity.",
  STUDENT: "Student",
  LAST_MOOD: "Last Mood Check-in",
  LAST_BLS: "Last BLS Session",
};

export default typography;
